<template>
    <div class="container">
        <div class="container">
            <div class="top">
                <img style="width: 100vw; height: 52vw" src="../assets/debt_bg.webp" />
                <div class="title">待还款账单</div>

                <div @click="back" style="width: 16vw; height: 16vw; position: absolute; display: flex; align-items: center; top: 2vw; left: 2vw">
                    <img style="width: 10vw; height: 7.93vw;" src="../assets/back.png" />
                </div>

                <div class="container_top">
                    <span style="font-size: 14px; color: #333; margin-top: 4vw; margin-left: 4vw;">待还款账单（共计）</span>
                    <span style="font-size: 20px; color: #FF000D; margin-top: 1.5vw; margin-left: 4vw;">-{{ debt_number }}</span>
                </div>

                <div class="container_bottom">
                    <div style="display: flex; margin-bottom: 4vw;">
                        <div @click="tabChange(0)" class="container_title_item">
                            <span :class="tabIndex == 0 ? 'container_title' : 'container_title_unselect'">全部</span>
                            <div v-if="tabIndex == 0" class="container_title_bottom"></div>
                        </div>
                        <div @click="tabChange(1)" class="container_title_item">
                            <span :class="tabIndex == 1 ? 'container_title' : 'container_title_unselect'">待还款</span>
                            <div v-if="tabIndex == 1" class="container_title_bottom"></div>
                        </div>
                        <div @click="tabChange(2)" class="container_title_item">
                            <span :class="tabIndex == 2 ? 'container_title' : 'container_title_unselect'">已还款</span>
                            <div v-if="tabIndex == 2" class="container_title_bottom"></div>
                        </div>
                    </div>

                    <div v-for="item in listAll" :key="item.id" class="debt_item">
                        <div style="display: flex;">
                            <div style="display: flex; flex-direction: column; justify-content: center; padding-left: 20px;">
                                <span style="font-size: 16px; color: #666">{{ item.repay_state == 1 ? '待' : '已' }}还款账单：</span>
                                <span style="margin-top: 10px; font-size: 20px; color: #FF5252">-{{ item.debt_money }}</span>
                            </div>
                            <div style="flex: 1"></div>
                            <div v-if="item.repay_state == 1" style="display: flex; flex: 1; justify-content: center; align-items: center; margin-right: 10px;">
                                <div @click="payDebt(item)" style="display: flex; width: 22vw; height: 6vw; margin-top: 2vw; color: #FF5252; align-items: center; justify-content: center; border: 1px solid #FF5252; border-radius: 4vw;">
                                    立即还款
                                </div>
                            </div>
                        </div>
                        <span v-if="item.comment.length > 0" style="font-size: 14px; color: #666; margin-left: 4vw; margin-top: 4vw;">{{ item.comment }}</span>
                    </div>

                    <div @click="getListMore" v-if="showBtnMore" class="list_more">点击加载更多</div>
                </div>
            </div>
         
        </div>

        <div @click="hideModal" class="debt_modal" v-if="showModal">
            <div @click="actionModalInner" class="modal_inner">
                <span style="font-size: 14px; color: #666; margin-top: 4vw; margin-left: 4vw;">待还款账单：</span>
                <span style="font-size: 22px; color: #FF5252; margin-top: 2vw; margin-left: 4vw;">-{{ this.pay_now_number.toFixed(2) }}</span>

                <div style="display: flex; margin-left: 4vw; margin-top: 2vw; align-items: center;">
                    <img style="width: 5vw; height: 5vw" src="../assets/jifen.webp" />
                    <span style="font-size: 14px; color: #333; margin-left: 1vw">积分（{{ this.user_score }}）</span>
                </div>
                <input class="input_modal" type="number" placeholder="请输入还款积分" v-model="pay_jifen" @input="handleJifen"/>


                <div style="display: flex; margin-left: 4vw; margin-top: 2vw; align-items: center;">
                    <img style="width: 5vw; height: 5vw" src="../assets/diamond.webp" />
                    <span style="font-size: 14px; color: #333; margin-left: 1vw">钻石（{{ this.user_jewel }}）</span>
                </div>
                <input class="input_modal" type="number" placeholder="请输入还款钻石" v-model="pay_diamond" @input="handleJifen"/>

                <div style="display: flex; margin-left: 4vw; margin-top: 2vw; align-items: center;">
                    <img style="width: 5vw; height: 5vw" src="../assets/coin.webp" />
                    <span style="font-size: 14px; color: #333; margin-left: 1vw">邀请积分（{{ this.user_coin }}）</span>
                </div>
                <input class="input_modal" type="number" placeholder="请输入还款邀请积分" v-model="pay_coin" @input="handleJifen"/>

                <div style="display: flex; margin-left: 4vw; margin-top: 2vw; align-items: center;">
                    <img style="width: 5vw; height: 5vw" src="../assets/gold.webp" />
                    <span style="font-size: 14px; color: #333; margin-left: 1vw">金币（{{ this.user_gold }}）</span>
                </div>
                <input class="input_modal" type="number" placeholder="请输入还款金币" v-model="pay_gold" @input="handleJifen"/>


                <div style="flex: 1"></div>
                <div @click="payNow()" class="button">
                    立即还款
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import axios from 'axios';
import ProfitHelper from '../ProfitHelper';
import { prefix, prefix_dev, userBankSetPassword, userDebtBillList, userDebtBillRepay, userFinance } from '../url';

export default ({
    data() {
        return {
            urlPrefix: prefix,
            head: {
                version: '',
                edition: '',
                aps: '',
                Authorization: '',
                os: 1,
            },

            password: '',
            tabIndex: 0,
            user_score: 0.00,
            user_jewel: 0.00,
            user_cryst: 0.00,
            debt_number: 0.00,

            listAll: [],
            page: 1,
            showBtnMore: true,

            showModal: false,
            pay_now_number: 0.00,
            pay_now_numer_copy: 0.00,
            pay_id: '',
            pay_jifen: '',
            pay_diamond: '',
            pay_coin: '',
            pay_gold: ''
        };
    },

    created() {
        this.formatUrlParams();
        this.getListAll();
    },

    methods: {
        back() {
            const backUrl = localStorage.getItem('is_dev') == 'yes' ? '/profit-dev?version=' : '/profit?version=';
            window.location.href = backUrl + this.head.version + '&edition=' + this.head.edition + "&aps=" + this.head.aps + "&Authorization=" + this.head.Authorization;
        },

        formatUrlParams() {
            if (localStorage.getItem('is_dev') == 'yes') {
                this.urlPrefix = prefix_dev;
            }
            this.head.version = localStorage.getItem('version');
            this.head.edition = localStorage.getItem('edition');
            this.head.aps = localStorage.getItem('aps');
            this.head.Authorization = localStorage.getItem('Authorization');

            this.debt_number = localStorage.getItem('total_debtbill_money');
            this.user_score = parseFloat(localStorage.getItem("user_score"));
            this.user_jewel = parseFloat(localStorage.getItem("user_jewel"));
            this.user_coin = parseFloat(localStorage.getItem("user_coin"));
            this.user_gold = parseFloat(localStorage.getItem("user_gold"));
        },

        btnConfirm() {
            const str = localStorage.getItem('PASSWORD_SET');

            if (this.password != str) {
                alert('两次密码不一致！')
                return;
            }

            const url = this.urlPrefix + userBankSetPassword;
            let params = {
                password: str,
                repassword: this.password
            };
            params.sign = ProfitHelper.getPostSign(JSON.stringify(params));
            axios.post(url, params, { headers: this.head }).then(res => {
                const data = res.data.data;
                if (data == true) {
                    window.location.href = '/profit-account';
                } else {
                    alert(res.data.msg);
                }
            })
        },

        // 获取服务器的一些数据
        getListAll() {
            let state = 1;
            switch(this.tabIndex) {
                case 0:
                    state = 0;
                    break;

                case 1:
                    state = 1;
                    break;

                case 2:
                    state = 3;
                    break
            }
            const url = this.urlPrefix + userDebtBillList + "?page_size=10&page=" + this.page + "&repay_state=" + state;
            axios.get(url, { headers: this.head }).then(res => {
                const data = res.data.data;

                if (this.page == 1) {
                    this.listAll = data.list.list;
                } else {
                    this.listAll = this.listAll.concat(data.list.list);
                }
                this.showBtnMore = data.list.has_next;
                // console.log('res data va si - - - ----->', data);
            })
        },

        getListMore() {
            this.page += 1;
            this.getListAll();
        },

        getUserFinance() {
            const url = this.urlPrefix + userFinance;
            axios.get(url, {
                headers: this.head,
            }).then(res => {
                console.log('user finance si - - -- -- ----->', res.data.data);
                const data = res.data.data;
                this.user_score = parseFloat(data.user_score);
                this.user_jewel = parseFloat(data.user_jewel);
                this.user_cryst = parseFloat(data.user_cryst);
                this.user_coin = parseFloat(data.user_coin);
                this.user_gold = parseFloat(data.user_gold);

                this.debt_number = parseFloat(data.total_debtbill_money);
                this.numAll = this.user_score + this.user_jewel + this.user_cryst;

                localStorage.setItem('total_debtbill_money', data.total_debtbill_money);
                localStorage.setItem("user_score", data.user_score);
                localStorage.setItem("user_jewel", data.user_jewel);
                localStorage.setItem("user_cryst", data.user_cryst);
                localStorage.setItem('user_gold', data.user_gold);
                localStorage.setItem('user_coin', data.user_coin);
            }).catch(err => { });
        },

        // 页面方法
        tabChange(index) {
            if (this.tabIndex == index) return;
            this.tabIndex = index;
            this.page = 1;
            this.getListAll();
        },

        payDebt(item) {
            this.showModal = true;
            this.pay_now_number = parseFloat(item.debt_money);
            this.pay_now_numer_copy = parseFloat(item.debt_money);
            this.pay_id = item.id;
        },

        hideModal() {
            this.showModal = false;
            this.pay_coin = '';
            this.pay_diamond = '';
            this.pay_gold = '';
            this.pay_jifen = '';
        },

        actionModalInner() {
            event.stopPropagation();
        },

        handleJifen(event) {
            const jifen = this.pay_jifen.length > 0 ? parseFloat(this.pay_jifen) : 0;
            const diamond = this.pay_diamond.length > 0 ? parseFloat(this.pay_diamond) : 0;
            const gold = this.pay_gold.length > 0 ? parseFloat(this.pay_gold) : 0;
            const coin = this.pay_coin.length > 0 ? parseFloat(this.pay_coin) : 0;
            this.pay_now_number = this.pay_now_numer_copy - jifen - diamond - gold - coin;
        },

        payNow() {
            const url = this.urlPrefix + userDebtBillRepay;
            let params = {
                id: this.pay_id,
                user_gold: this.pay_gold,
                user_jewel: this.pay_diamond,
                user_score: this.pay_jifen,
                user_cryst: 0,
                user_coin: this.pay_coin,
            }
            params.sign = ProfitHelper.getPostSign(JSON.stringify(params));
            axios.post(url, params, { headers: this.head }).then(res => {
                const data = res.data.data;
                if (data.id != null) {
                    this.getListAll();
                    this.getUserFinance();
                    this.hideModal();
                    alert('恭喜您还款成功！');
                } else {
                    alert(res.data.msg);
                }
            })
        }
    }
})
</script>



<style scoped>
.container {
    width: 100%;
    min-height: 100vh;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #FBF2E7;
    /* padding-bottom: 2vw; */
}

.top {
    width: 100vw;
    height: 74.6vw;
    display: flex;
    flex-direction: column;
}
.title {
    position: absolute;
    top: 6vw;
    width: 100%;
    text-align: center;
    font-size: 19px;
    font-weight: 500;
}

.input_p {
    width: 60vw;
    height: 12vw;
    margin-top: 10vw;
    margin-left: 20vw;
    border: 1px #EEE solid;
    border-radius: 12px;
    text-align: center;
    font-size: 24px;
}
.btn_next {
    display: flex;
    width: 88vw;
    height: 12vw;
    background: linear-gradient(to right, #CBACFF, #7384FF);
    align-self: center;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
    color: white;
    border-radius: 28px;
    margin-top: 10vw;
}

.container_top {
    width: 90vw;
    height: 20vw;
    background-color: white;
    margin-left: 5vw;
    border-radius: 8px;
    margin-top: -30vw;
    display: flex;
    flex-direction: column;
}
.container_bottom {
    width: 90vw;
    /* min-height: 80vh; */
    margin-left: 5vw;
    margin-top: 8vw;
    padding-bottom: 10vw;
    background-color: white;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    border: 1px #EEE solid;
    /* background: red; */
}
.container_title_item {
    display: flex;
    flex-direction:
    column;
    flex: 1;
    justify-content: center;
    align-items: center;
}
.container_title {
    color: #7678FF;
    margin-top: 3vw;
}
.container_title_unselect {
    color: #333;
    margin-top: 3vw;
}
.container_title_bottom {
    width: 5vw;
    height: 0.8vw;
    background-color: #7678FF;
    border-radius: 0.4vw;
    margin-top: 0.5vw;
}

.debt_item {
    width: 80vw;
    /* height: 26vw; */
    margin-left: 5vw;
    margin-top: 3vw;
    padding-top: 4vw;
    padding-bottom: 4vw;
    border-radius: 8px;
    background-color: #FEF7EC;
    display: flex;
    flex-direction: column;
}
.debt_modal {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}
.modal_inner {
    width: 80vw;
    height: 130vw;
    border-radius: 8px;
    background: linear-gradient(to bottom, rgb(250, 224, 202), white);
    display: flex;
    flex-direction: column;
}
.input_modal {
    margin-left: 4vw;
    margin-top: 2vw;
    width: 70vw;
    height: 8vw;
    font-size: 13px;
    background: transparent;
    border: 1px #CCC solid;
    border-top-width: 0px;
    border-left-width: 0px;
    border-right-width: 0px;
    border-bottom-width: 1px;
}

.button {
    display: flex;
    width: 60vw;
    height: 8vw;
    margin-top: 2vw;
    margin-left: 10vw;
    margin-bottom: 6vw;
    color: #FF000D;
    align-items: center;
    justify-content: center;
    border: 1px solid #FF000D;
    border-radius: 4vw;
}
.list_more {
    width: 80vw;
    height: 12vw;
    border: 1px #CCC solid;
    margin-left: 5vw;
    margin-top: 5vw;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #999;
}
</style>